import React from 'react';

import { BiUserCircle } from 'react-icons/bi';
import { MdOutlinePermContactCalendar, MdOutlineVpnKey } from 'react-icons/md';
import { VscHome } from 'react-icons/vsc';

import { useSetValuesProfile } from '../hooks/useSetValuesProfile';

import { Container, Form } from './styles';

import { Box, BootstrapForm, InputText } from '../styles';

const FormProfile: React.FC = () => {
  const {
    company,
    documentClient,
    customerCode,
    customerSiteCode,
    addressBill,
    addressShip,
    addressLetter,
  } = useSetValuesProfile();

  return (
    <Container>
      <Form>
        <Box>
          <BootstrapForm.Group controlId="company">
            <InputText
              type="text"
              label="Nome da conta:"
              ariaLabel="Nome da conta:"
              ariaRequired
              title="Nome da conta:"
              placeholder="Nome da conta:"
              value={company}
              disabled
              LeadingIcon={() => <BiUserCircle size={24} color="#7a7a7a" />}
            />
          </BootstrapForm.Group>
        </Box>
        <Box>
          <BootstrapForm.Group controlId="document">
            <InputText
              type="text"
              label="CNPJ/CPF:"
              ariaLabel="CNPJ/CPF:"
              ariaRequired
              title="CNPJ/CPF:"
              placeholder="CNPJ/CPF:"
              value={documentClient}
              disabled
              LeadingIcon={() => (
                <MdOutlinePermContactCalendar size={24} color="#7a7a7a" />
              )}
            />
          </BootstrapForm.Group>
        </Box>
        <Box>
          <BootstrapForm.Group controlId="customerCode">
            <InputText
              type="text"
              label="Código do Cliente:"
              ariaLabel="Código do Cliente:"
              ariaRequired
              title="Código do Cliente:"
              placeholder="Código do Cliente:"
              value={customerCode}
              disabled
              LeadingIcon={() => <MdOutlineVpnKey size={24} color="#7a7a7a" />}
            />
          </BootstrapForm.Group>
        </Box>
        <Box>
          <BootstrapForm.Group controlId="customerSiteCode">
            <InputText
              type="text"
              label="Código do Endereço:"
              ariaLabel="Código do Endereço:"
              ariaRequired
              title="Código do Endereço:"
              placeholder="Código do Endereço:"
              value={customerSiteCode}
              disabled
              LeadingIcon={() => <MdOutlineVpnKey size={24} color="#7a7a7a" />}
            />
          </BootstrapForm.Group>
        </Box>
        <Box>
          <BootstrapForm.Group controlId="addressBill">
            <InputText
              type="text"
              label="Endereço de fatura:"
              ariaLabel="Endereço de fatura:"
              ariaRequired
              title="Endereço de fatura:"
              placeholder="Endereço de fatura:"
              value={`${addressBill?.addressLine}, ${addressBill?.addressNumber} ${addressBill?.complement}`}
              disabled
              LeadingIcon={() => <VscHome size={24} color="#7a7a7a" />}
            />
          </BootstrapForm.Group>
        </Box>
        {addressShip?.addressLine && (
          <Box>
            <BootstrapForm.Group controlId="addressShip">
              <InputText
                type="text"
                label="Endereço de entrega:"
                ariaLabel="Endereço de entrega:"
                ariaRequired
                title="Endereço de entrega:"
                placeholder="Endereço de entrega:"
                value={`${addressShip?.addressLine}, ${addressShip?.addressNumber} ${addressShip?.complement}`}
                disabled
                LeadingIcon={() => <VscHome size={24} color="#7a7a7a" />}
              />
            </BootstrapForm.Group>
          </Box>
        )}
        {addressLetter?.addressLine && (
          <Box>
            <BootstrapForm.Group controlId="addressLetter">
              <InputText
                type="text"
                label="Endereço de Cobrança:"
                ariaLabel="Endereço de Cobrança:"
                ariaRequired
                title="Endereço de Cobrança:"
                placeholder="Endereço de Cobrança:"
                value={`${addressLetter?.addressLine}, ${addressLetter?.addressNumber} ${addressLetter?.complement}`}
                disabled
                LeadingIcon={() => <VscHome size={24} color="#7a7a7a" />}
              />
            </BootstrapForm.Group>
          </Box>
        )}
      </Form>
    </Container>
  );
};

export default FormProfile;
